import { render } from "./QuoteRequests.vue?vue&type=template&id=5019d694"
import script from "./QuoteRequests.vue?vue&type=script&lang=js"
export * from "./QuoteRequests.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__